import * as yup from "yup";

const schema = yup.object().shape({
  sale_time: yup.string().required("Para salvar, insira uma data."),
});

export default schema;
